import React from "react";
import { FaClipboardList } from "react-icons/fa";
import { FaLock } from "react-icons/fa";
import "./QbankCard.scss";
import { AiOutlineStar } from "react-icons/ai";
import { BsDot } from "react-icons/bs";
import { MdKeyboardArrowRight } from "react-icons/md";

export default function QbankCard(props) {
  return (
    <div className="custom_card qbank_card">
      <div className={`card_image_container video_thumbnail_container ${true ? "" : "deactivate"}`}>{true ? <FaClipboardList /> : <FaLock />}</div>
      <div className="card_info_container">
        <h6 className="qbank_title">Plasma is something there</h6>

        <div className="card_detail">
          <div className="rating_container">
            <AiOutlineStar />
            {5.0}
          </div>
          <BsDot />
          <p>{20} Ques</p>
        </div>
      </div>
      <MdKeyboardArrowRight className="right_arrow_icon" />
    </div>
  );
}
